exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-sheet .v-calendar .v-calendar-daily_head-day{border-right:0}.v-sheet .v-calendar .v-calendar-daily_head-day .v-calendar-daily_head-weekday{color:#949a9f;font-family:Nunito,sans-serif;font-size:14px}.v-sheet .v-calendar .v-calendar-daily_head-day .v-calendar-daily_head-day-label button.v-btn{background:#adebff;color:#444a4f;font-family:Nunito,sans-serif;font-size:18px;height:46px;width:46px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f0d75de","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/styles/Calendar.scss
// module id = 1015
// module chunks = 0